// src/axios.js
import axios from 'axios';

// Set the base URL for all Axios requests
const axiosInstance = axios.create({
  baseURL: 'https://www.reserveplace.ai/api/v1',  // Replace with your backend base URL
  headers: {
    'Content-Type': 'application/json',  // Set default headers if needed
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // No need to handle token updates for JWT as they're stateless
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Redirect to login or show message
      window.location.href = '/login';  // or use your router
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
